<template>
  <div class="row reverse-mobile justify-content-center">
    <AdminMenu />

    <div class="col-12 col-md-9 center-content">
      <CommunityCard>
        <div class="my-3 p-3 rounded">
          <CreateForumPost :isGroup="false" :groupId="-1" />
        </div>
      </CommunityCard>
    </div>
  </div>
</template>

<script>
import AdminMenu from "@/components/AdminMenu";
import CreateForumPost from "@/components/CreateForumPost/CreateForumPost";
import CommunityCard from "@/components/CommunityCard";

export default {
  name: "AdminForumPost",
  components: {
    CommunityCard,
    AdminMenu,
    CreateForumPost,
  },
};
</script>
